import type { BusinessProcessDetail } from './types'

// Human-authored context is supporting information for the workflow above.
// Keep it in one reading surface instead of presenting an empty source field
// with the same visual weight as the process objective.
export default function ProcessHumanSummary({ process }: { process: BusinessProcessDetail }) {
  return (
    <section className="space-y-4" aria-labelledby="process-context-heading">
      <div>
        <h2 id="process-context-heading" className="text-lg font-semibold">Contexto do processo</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Resultado esperado e informações que orientam a execução.
        </p>
      </div>

      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <div className="p-5">
          <h3 className="text-sm font-medium text-foreground">Resultado esperado</h3>
          <p className="mt-2 whitespace-pre-wrap text-sm leading-relaxed text-foreground">
            {process.objective}
          </p>
        </div>

        <div className="border-t border-border p-5">
          <h3 className="text-sm font-medium text-foreground">Fontes de apoio</h3>
          <p className={`mt-2 whitespace-pre-wrap text-sm leading-relaxed ${
            process.sources ? 'text-foreground' : 'text-muted-foreground'
          }`}>
            {process.sources || 'Este processo não possui fontes de apoio vinculadas.'}
          </p>
        </div>
      </div>
    </section>
  )
}
